import AppConstants from '../../Constants/AppConstants';

const storageKey = name => `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:categories:${name}`;
const fields = [
  'name', 'status', 'rank', 'categoryTypeField', 'parentId',
  'backendParentID', 'selectedParentId', 'descriptionString', 'slugValue',
  'metaDescriptionString', 'metaTitle', 'attributeArray',
];
const clean = (value, depth = 0) => {
  if (depth > 5) return undefined;
  if (value === null || ['string', 'number', 'boolean'].includes(typeof value)) return value;
  if (Array.isArray(value)) return value.length < 300 ? value.map(item => clean(item, depth + 1)).filter(item => item !== undefined) : undefined;
  if (!value || typeof value !== 'object' || (typeof File !== 'undefined' && value instanceof File) || (typeof Blob !== 'undefined' && value instanceof Blob)) return undefined;
  const result = {};
  for (const [key, child] of Object.entries(value)) {
    if (/password|token|secret|credential|authorization|bearer|base64|file|image/i.test(key)) continue;
    const sanitized = clean(child, depth + 1);
    if (sanitized !== undefined) result[key] = sanitized;
  }
  return result;
};

export const readCategoryDraft = name => {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(window.localStorage.getItem(storageKey(name)) || '{}') || {};
  } catch (error) {
    return {};
  }
};

export const writeCategoryDraft = (name, state) => {
  if (typeof window === 'undefined') return;
  try {
    const draft = Object.fromEntries(fields.map(field => [field, clean(state[field])]).filter(([, value]) => value !== undefined));
    const value = JSON.stringify(draft);
    if (value.length < 200000) window.localStorage.setItem(storageKey(name), value);
  } catch (error) {
    // Local storage is optional; the category form remains usable if unavailable.
  }
};

export const clearCategoryDraft = name => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(storageKey(name));
  } catch (error) {
    // Ignore storage errors during explicit discard or after a successful save.
  }
};
